module.exports = "<div class=\"np-site-page clearfix section-full-height section-scrollable\">\n  <div class=\"np-site-header\">\n    <a href=\"http://www.nightpro.co/\" class=\"logo\">\n      <img src=\"" + require("../../assets/images/nightpro_logo_site.png") + "\">\n    </a>\n    <div class=\"branding\">\n      <a class=\"powered-by\" href=\"https://www.tablelist.com\" target=\"_blank\">by <img src=\"" + require("../../assets/images/tablelist-logo.png") + "\" alt=\"Tablelist\"></a>\n    </div>\n  </div>\n  <div class=\"animated fadeInUp\" ng-transclude>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/npSitePage/template.html
// module id = 1227
// module chunks = 0